import app from "../firebase";
import { getFunctions, httpsCallable } from "firebase/functions";

const callPortalAction = async (credentialScope, portalAction, data = {}) => {
  const callable = httpsCallable(
    getFunctions(app, "us-central1"),
    "portalCredentials"
  );
  return (await callable({ credentialScope, portalAction, ...data })).data;
};

export const listPortalCredentials = async (credentialScope) => {
  return callPortalAction(credentialScope, "list");
};

export const savePortalCredential = async (credentialScope, credential) => {
  return callPortalAction(credentialScope, "save", credential);
};

export const revealPortalCredentialPassword = async (credentialScope, id) => {
  return (await callPortalAction(credentialScope, "reveal", { id })).password;
};

export const deletePortalCredential = async (credentialScope, id) => {
  return callPortalAction(credentialScope, "delete", { id });
};

export const importPortalCredentials = async (credentialScope, rows) => {
  return callPortalAction(credentialScope, "import", { rows });
};
